<script setup lang="ts">
import { onMounted, ref } from "vue";

import { LoadingIcon } from "~/icons";
import { timeout } from "~/utils/wait";

defineProps<{
  absolute?: boolean;
  small?: boolean;
  xSmall?: boolean;
}>();

const isShown = ref(false);
const isVisible = ref(false);

onMounted(async () => {
  await timeout(300);
  isShown.value = true;
  requestAnimationFrame(() => {
    isVisible.value = true;
  });
});
</script>

<template>
  <div
    v-if="isShown"
    class="pointer-events-none w-full items-center justify-center transition-opacity duration-300 ease-in-out"
    :class="[absolute && 'absolute inset-0', isShown ? 'flex' : 'hidden', isVisible ? 'opacity-100' : 'opacity-0']">
    <LoadingIcon class="animate-spin text-vlt" :class="[small ? 'size-6' : xSmall ? 'size-4' : 'size-8']" />
  </div>
</template>
